var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F9F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9224 19.7714H28.4634L24.0125 6.02344L19.5352 19.7714L5.07617 19.745L16.7698 28.2519L12.2925 41.9998L23.9861 33.4929L35.6798 41.9998L31.2288 28.2519L42.9224 19.7714Z",
    fill: "#1B4458",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2289 31.3578L31.2281 28.25L24.0117 33.4911L32.2289 31.3578Z",
    fill: "#1B4458"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.3dd770cb01ac70624e1af36f5cf6e6a8.svg";
export { ForwardRef as ReactComponent };